import React, { useEffect, useState } from "react";
import { FaUser, FaEnvelope, FaMapMarkerAlt, FaPhone, FaPen, FaKey } from "react-icons/fa";
import Header from "../Components/Header";
import Cookies from "universal-cookie";
import "./profile.css";
import * as Constant from "../Constant";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";
import { Link } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from '@emotion/core';
// Modal Komponen untuk Edit Field

const override = css`
  display: block;
  margin: 0 auto;
  border-color: #ea6123 solid 2px;
`;
const Modal = ({ field, value, onClose, onSave }) => {
    const [inputValue, setInputValue] = useState(value);

    const handleSave = () => {
        onSave(field, inputValue);
        onClose(); // Close modal after saving
    };

    return (
        <>
            <div className="modal-overlay" onClick={onClose}></div>
            <div className="modal-content">
                <p className="modal-title">Masukkan {field} anda</p>
                <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    className="modal-value"
                    autoFocus={true}
                />
                <div className="modal-actions">
                    <button onClick={onClose}>Cancel</button>
                    <button onClick={handleSave}>Save</button>
                </div>
            </div>
        </>
    );
};

// Modal Komponen untuk Ganti Password
const PasswordModal = ({ onClose, onChangePassword }) => {
    const [oldPassword, setOldPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const handleSave = () => {
        onChangePassword(oldPassword, newPassword);
        onClose(); // Close modal after saving
    };

    return (
        <>
            <div className="modal-overlay" onClick={onClose}></div>
            <div className="modal-content-password">
                <p className="modal-title-password">Ganti Password</p>
                <input
                    type="password"
                    placeholder="Password Lama"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    className="modal-value-password"
                    autoFocus={true}
                />
                <input
                    type="password"
                    placeholder="Password Baru"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    className="modal-value-password"
                />
                <div className="modal-actions">
                    <button onClick={onClose}>Cancel</button>
                    <button onClick={handleSave}>Save</button>
                </div>
            </div>
        </>
    );
};

const Profile = () => {
    const [user, setUser] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
    const [currentField, setCurrentField] = useState("");
    const [selectedFile, setSelectedFile] = useState(null); // State untuk file gambar
    const [loading, setLoading] = useState(true);



    const cookies = new Cookies();

    useEffect(() => {
        const accessToken = cookies.get("accessToken");

        if (accessToken) {
            fetch(`${Constant.GET_USER}`, {
                method: "GET",
                headers: {
                    Authorization: `${accessToken}`,
                },
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to fetch user data");
                    }
                    return response.json();
                })
                .then((data) => {
                    setUser({
                        ...data,
                        profilePicture: data.profilePicture
                            ? `${Constant.GET_PROFILE_PICTURE}${data.id}`
                            : '/profile-default.png',
                    });
                })
                .catch((error) => {
                    console.error(error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }  else {
            setLoading(false);
        }
    }, []);

    const handleEdit = (field) => {
        setCurrentField(field);
        setIsModalOpen(true);
    };

    const handleSave = (field, newValue) => {
        const accessToken = cookies.get("accessToken");

        if (accessToken) {
            fetch(`${Constant.UPDATE_PROFILE}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${accessToken}`,
                },
                body: JSON.stringify({ [field]: newValue }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to update profile");
                    }
                    return response.json();
                })
                .then(() => {
                    setUser((prevUser) => ({
                        ...prevUser,
                        [field]: newValue,
                    }));
                })
                .catch((error) => console.error(error));
        }
    };

    const handleChangePassword = (oldPassword, newPassword) => {
        const accessToken = cookies.get("accessToken");

        if (accessToken) {
            fetch(`${Constant.CHANGE_PASSWORD}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `${accessToken}`,
                },
                body: JSON.stringify({ old_password: oldPassword, new_password: newPassword }),
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to change password");
                    }
                    alert("Password berhasil diubah!");
                })
                .catch((error) => console.error(error));
        }
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]); // Simpan file yang dipilih
    };

    const handleUpdateProfilePicture = () => {
        if (!selectedFile) return alert("Pilih gambar terlebih dahulu!");

        const accessToken = cookies.get("accessToken");
        const formData = new FormData();
        formData.append("photo", selectedFile);

        if (accessToken) {
            fetch(`${Constant.UPDATE_PROFILE_PICTURE}`, {
                method: "POST",
                headers: {
                    Authorization: `${accessToken}`,
                },
                body: formData,
            })
                .then((response) => {
                    if (!response.ok) {
                        throw new Error("Failed to update profile picture");
                    }
                    return response.json();
                })
                .then((data) => {
                    setUser((prevUser) => ({
                        ...prevUser,
                        profilePicture: data.profilePictureUrl,
                    }));
                    alert("Foto profil berhasil diperbarui!");
                })
                .catch((error) => console.error(error));
        }
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleClosePasswordModal = () => {
        setIsPasswordModalOpen(false);
    };


    return (
        <div>
            <Header />
            {loading ? (
                <div className="loading-container">
                    <ClipLoader css={override} size={150} color={"#ea6123"} loading={loading} />
                </div>
            ) : (
                <>
                    <header>
                        <nav className="left header-kembali">
                            <Link to="/akun">
                                <i
                                    id="ic-sidebar"
                                    className="fa fa-arrow-left"
                                    style={{
                                        marginLeft: '10px',
                                        marginRight: '10px',
                                    }}
                                ></i>
                                Profile
                            </Link>
                        </nav>
                    </header>
                    <div className="profile-container">
                        <div className="header-profile">
                            <img
                                src={user.profilePicture || '/profile-default.png'}
                                alt="Profile Picture"
                                className="profile-picture"
                                onClick={() => document.getElementById("profile-picture-input").click()}
                            />
                            <input
                                id="profile-picture-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={handleFileChange}
                            />
                            {selectedFile && (
                                <button onClick={handleUpdateProfilePicture} className="update-picture-button">
                                    Perbarui Foto
                                </button>
                            )}
                        </div>

                        <div className="profile-info">
                            <div className="info-item-profile">
                                <FaUser className="info-icon" />
                                <div className="info-column">
                                    <label className="info-label">Nama:</label>
                                    <span className="info-text">{user.name || "Belum diisi"}</span>
                                </div>
                                <FaPen className="chevron-icon" onClick={() => handleEdit("name")} />
                            </div>
                            <div className="info-item-profile">
                                <FaEnvelope className="info-icon" />
                                <div className="info-column">
                                    <label className="info-label">Email:</label>
                                    <span className="info-text">{user.email || "Belum diisi"}</span>
                                </div>
                            </div>
                            <div className="info-item-profile">
                                <FaMapMarkerAlt className="info-icon" />
                                <div className="info-column">
                                    <label className="info-label">Alamat:</label>
                                    <span className="info-text">{user.alamat || "Belum diisi"}</span>
                                </div>
                                <FaPen className="chevron-icon" onClick={() => handleEdit("alamat")} />
                            </div>
                            <div className="info-item-profile">
                                <FaPhone className="info-icon" />
                                <div className="info-column">
                                    <label className="info-label">Telepon:</label>
                                    <span className="info-text">{user.no_telp || "Belum diisi"}</span>
                                </div>
                                <FaPen className="chevron-icon" onClick={() => handleEdit("no_telp")} />
                            </div>
                            <div className="password-button-container">
                                <button
                                    className="password-button"
                                    onClick={() => setIsPasswordModalOpen(true)}
                                >
                                    Ganti Password
                                </button>
                            </div>

                        </div>
                    </div>
                </>
            )}

            {isModalOpen && (
                <Modal
                    field={currentField}
                    value={user[currentField] || ""}
                    onClose={handleCloseModal}
                    onSave={handleSave}
                />
            )}

            {isPasswordModalOpen && (
                <PasswordModal
                    onClose={handleClosePasswordModal}
                    onChangePassword={handleChangePassword}
                />
            )}
        </div>
    );
};

export default Profile;
